(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["B-featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (customElements.get('product-modal') === undefined) {
    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.getElementById('shopify-section-announcement-bar');
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.collFilters = document.querySelector('.coll-filters');
      this.proInfo = document.querySelector('.product__info-container--sticky');
      this.filterDrawer = document.querySelector('.coll-filter-drawer');
      this.filterDrawerForm = document.querySelector('.coll-filter-drawer__form');
      this.deleyTop = this.collFilters && this.announcementBar ? this.announcementBar.offsetHeight + this.header.offsetHeight : this.header.offsetHeight;
      this.deleyTop = this.header.offsetHeight;  
      this.collFilters && this.collFilters !== null ? this.collFilters.style.top = this.deleyTop + 'px' : null;
      if(document.querySelector('.header-position-fixed') !== null){
         this.proInfo && this.proInfo !== null ? this.proInfo.style.top = this.deleyTop + 'px' : null;
      }else{
         this.proInfo && this.proInfo !== null ? this.proInfo.style.top = -10  + 'px' : null;
      }
      this.filterDrawer && this.filterDrawer !== null && this.announcementBar && this.announcementBar !== null ? this.filterDrawer.style.top = this.announcementBar.offsetHeight + 'px' : null;
      this.filterDrawerForm && this.filterDrawerForm !== null && this.announcementBar && this.announcementBar !== 'null' ? this.filterDrawerForm.style.height = 'calc(100vh - ' + (169 + this.announcementBar.offsetHeight) + 'px)' : null; 

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*document.querySelector('[data-currency-selector]').addEventListener('change', function(e){
    this.closest('form').submit();
  });*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.getElementById('shopify-section-announcement-bar');
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.collFilters = document.querySelector('.coll-filters');
      this.proInfo = document.querySelector('.product__info-container--sticky');
      this.filterDrawer = document.querySelector('.coll-filter-drawer');
      this.filterDrawerForm = document.querySelector('.coll-filter-drawer__form');
      this.deleyTop = this.collFilters && this.announcementBar ? this.announcementBar.offsetHeight + this.header.offsetHeight : this.header.offsetHeight;
      this.deleyTop = this.header.offsetHeight;  
      this.collFilters && this.collFilters !== null ? this.collFilters.style.top = this.deleyTop + 'px' : null;
      if(document.querySelector('.header-position-fixed') !== null){
         this.proInfo && this.proInfo !== null ? this.proInfo.style.top = this.deleyTop + 'px' : null;
      }else{
         this.proInfo && this.proInfo !== null ? this.proInfo.style.top = -10  + 'px' : null;
      }
      this.filterDrawer && this.filterDrawer !== null && this.announcementBar && this.announcementBar !== null ? this.filterDrawer.style.top = this.announcementBar.offsetHeight + 'px' : null;
      this.filterDrawerForm && this.filterDrawerForm !== null && this.announcementBar && this.announcementBar !== 'null' ? this.filterDrawerForm.style.height = 'calc(100vh - ' + (169 + this.announcementBar.offsetHeight) + 'px)' : null; 

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*document.querySelector('[data-currency-selector]').addEventListener('change', function(e){
    this.closest('form').submit();
  });*/


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-customize-blanket"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.blanket-option .thickness-option').forEach(item=>{
    item.addEventListener('click',function(){
      document.querySelector('.thickness-option.active')?.classList.remove('active');
      var thick_option = this.getAttribute('data-option');
      document.querySelector('.blanket-size-options').setAttribute('data-thickness',thick_option);
      this.classList.add('active');
      if(thick_option == "xlight"){        
        document.querySelector('.blanket-option .option-small')?.click();        
      }else if(thick_option != "light" && document.querySelector('.blanket-option .option-x-large.active') ){
        document.querySelector('.blanket-option .option-small')?.click();        
      }else{
        document.querySelector('.blanket-size-options .active')?.click();
      }      
    })
  })
  document.querySelectorAll('.blanket-size-options .size-option').forEach(item=>{
    item.addEventListener('click',function(){
      document.querySelector('.blanket-size-options .size-option.active')?.classList.remove('active');
      var thick_option = document.querySelector('.blanket-size-options').getAttribute('data-thickness');  
      var size_option = this.getAttribute('data-option');
      this.classList.add('active');
      document.querySelector('.custom_blankets-wraper .main-product-section.active')?.classList.remove('active');
      if(thick_option == "xlight"){
        document.querySelector('.custom_blankets-wraper .main-product-section[data-item="lil-marsh-traveler"]')?.classList.add('active');    
      }else if(thick_option == "light"){
        if(size_option == 'xl'){
          document.querySelector('.custom_blankets-wraper .main-product-section[data-item="the-cuddle-puddle"]')?.classList.add('active');
        }else{
          document.querySelector('.custom_blankets-wraper .main-product-section[data-item="lil-marsh"]')?.classList.add('active');
        }  
        if(size_option=="s"){
          document.querySelector('[data-item="lil-marsh"] label[data-value="XS"]').click()
        }else if(size_option=="m"){
          document.querySelector('[data-item="lil-marsh"] label[data-value="S"]').click()
        }else if(size_option=="l"){
          document.querySelector('[data-item="lil-marsh"] label[data-value="M"]').click()
        }
      }else{
        document.querySelector('.custom_blankets-wraper .main-product-section[data-item="marsh-2-0"]')?.classList.add('active');
        if(size_option=="s"){
          document.querySelector('[data-item="marsh-2-0"] label[data-value="S"]').click()
        }else if(size_option=="m"){
          document.querySelector('[data-item="marsh-2-0"] label[data-value="M"]').click()
        }else if(size_option=="l"){
          document.querySelector('[data-item="marsh-2-0"] label[data-value="L"]').click()
        }
      }      
    })
  })
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (customElements.get('product-modal') === undefined) {
    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (customElements.get('product-modal') === undefined) {
    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (customElements.get('product-modal') === undefined) {
    customElements.define('product-modal', ProductModal);
  }

  } catch(e) { console.error(e); }
})();
})();
